import React, { useState } from 'react';

import { message } from 'antd';
import styled from 'styled-components';

import ConfirmModal from 'common/Modal/ConfirmModal';
import axios from 'config/axiosPrivate';
import { useAppSelector } from 'store/hook';

const Email = styled.span`
  font-family: var(--font-bold);
`;

interface Props {
  open: boolean;
  handleClose: () => void;
  title?: string;
}

const Auth0PasswordResetModal: React.FC<Props> = ({ open, handleClose, title = '' }) => {
  const currentUser = useAppSelector((state) => state.auth.currentUser);
  const [loading, setLoading] = useState(false);

  const handleSendResetEmail = async () => {
    setLoading(true);
    try {
      await axios.post('/api/auth_changepassword/request_auth0_password_reset/');
      message.success('Password reset email sent! Check your inbox.');
      handleClose();
    } catch (err) {
      message.error('Failed to send password reset email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmModal
      open={open}
      title={title}
      description={
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span>
            A password reset email will be sent to <Email>{currentUser?.email}</Email>.
          </span>
          <span>Click the link in the email to set a new password.</span>
        </div>
      }
      loading={loading}
      confirmLabel="Send Reset Email"
      onConfirm={handleSendResetEmail}
      onCancel={handleClose}
    />
  );
};

export default Auth0PasswordResetModal;
